import { ActivityTemplate, TemplateStatus } from '../models';
import { Link } from 'react-router-dom';
import adminService from '../utils/api-calls/adminService';
import useLoading from '../contexts/LoadingContext';
import { useTranslation } from 'react-i18next';

function CopyToCreate({ template }: { template: ActivityTemplate }) {
  const [t] = useTranslation(['admin']);
  const newTemplate = {
    ...template,
    id: '',
    imageUrl: '',
    status: TemplateStatus.DRAFT,
  };
  return (
    <Link to={`new?copyFrom=${template.id}`} state={{ template: newTemplate }}>
      <button className="flex justify-center items-center gap-1 text-xs">
        <span className="material-symbols-outlined text-xs">content_copy</span>
        {t('duplicate', '複製')}
      </button>
    </Link>
  );
}

export function ActionButton({ template }: { template: ActivityTemplate }) {
  const [t] = useTranslation(['admin']);
  const { setIsLoading } = useLoading();
  if (template.status === TemplateStatus.DRAFT) {
    return (
      <Link to={`edit/${template.id}`} state={{ template }}>
        <button className="w-12 flex justify-center items-center gap-1 text-xs">
          <span className="material-symbols-outlined text-xs">edit_square</span>
          {t('edit', '編輯')}
        </button>
      </Link>
    );
  }

  if (template.status === TemplateStatus.EDITING) {
    return <CopyToCreate template={template} />;
  }

  const updateStatus = async (status: string) => {
    setIsLoading(true);
    await adminService
      .updateTemplateStatus({
        id: template.id,
        status,
      })
      .finally(() => setIsLoading(false));
    window.location.reload();
  };

  const stateButton =
    template.status === TemplateStatus.PUBLISHED ? (
      <button
        className="flex justify-center items-center gap-1 text-xs"
        onClick={() => updateStatus(TemplateStatus.ARCHIVED)}
      >
        <span className="material-symbols-outlined text-xs">archive</span>
        {t('archive', '封存')}
      </button>
    ) : (
      <button
        className="flex justify-center items-center gap-1 text-xs"
        onClick={() => updateStatus(TemplateStatus.PUBLISHED)}
      >
        <span className="material-symbols-outlined text-xs">publish</span>
        {t('publish', '發佈')}
      </button>
    );

  return (
    <div className="flex gap-2 w-full justify-evenly">
      <CopyToCreate template={template} />
      {stateButton}
    </div>
  );
}
